"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useLoginedUser = exports.useAuthenticated = exports.useInitialState = exports.useApp = void 0;
var tslib_1 = require("tslib");
var react_1 = require("react");
var core_1 = require("@jsmodules/core");
var di_1 = tslib_1.__importDefault(require("@jsmodules/di"));
var context_1 = require("./context");
function useApp() {
    return react_1.useContext(context_1.AppContext);
}
exports.useApp = useApp;
function useInitialState() {
    var _a = useApp(), loading = _a.loading, error = _a.error, initialState = _a.initialState, setInitialState = _a.setInitialState, refreshInitialState = _a.refreshInitialState;
    return { loading: loading, error: error, initialState: initialState, setInitialState: setInitialState, refreshInitialState: refreshInitialState };
}
exports.useInitialState = useInitialState;
function useAuthenticated() {
    var _a = useInitialState(), loading = _a.loading, initialState = _a.initialState, setInitialState = _a.setInitialState;
    return {
        loading: loading,
        isAuthenticated: initialState === null || initialState === void 0 ? void 0 : initialState.isAuthenticated,
        setAuthenticated: function (isAuthenticated) {
            var state = { isAuthenticated: isAuthenticated };
            if (isAuthenticated) {
                var session = di_1.default.getInstance(core_1.SessionService);
                state.user = session.user;
            }
            setInitialState(state);
        },
    };
}
exports.useAuthenticated = useAuthenticated;
function useLoginedUser() {
    var initialState = useInitialState().initialState;
    return (initialState === null || initialState === void 0 ? void 0 : initialState.user) || null;
}
exports.useLoginedUser = useLoginedUser;
